<div class="container">
    <div class="header">
        <h4 class="title">{{ 'system-color.title' | translate }}</h4>
        <span class="description">{{ 'system-color.description' | translate }}</span>
    </div>
    <div class="main-container">
        <div *ngFor="let systemColorContainer of systemColorContainerData">
            <app-system-color-container [data]="systemColorContainer" [canEditVessel]="userCanEdit">
            </app-system-color-container>
        </div>
        <app-custom-system-color-container
            [data]="customSystemColorContainerData"
            [vessel]="vessel"
            [canEditVessel]="userCanEdit">
        </app-custom-system-color-container>
    </div>
</div>
